export default __webpack_public_path__ + "e2e8e019d19760f5407186ff553ebfbb.png";